// MapWrapper.tsx
import React, { useState, useEffect } from 'react';
import { MapPanel } from './MapPanel'; // Original Leaflet component
import { MapPanelMapLibre } from './MapPanelMapLibre'; // New MapLibre component
//import { MapPanelGoogleMaps } from './MapPanelGoogleMaps'; // New MapLibre component

import { Location } from '../types/chat';

interface MapWrapperProps {
  view: 'osm' | 'google';
  locations: Location[];
  onLocationSelect: (location: Location | null) => void;
  isLoading: boolean;
  isStreaming: boolean;
  selectedLocation: Location | null;
  isProcessingLocation: boolean;
  showPopupForSelected?: boolean;
  chatPanelVisible?: boolean;
  chatPanelRef?: React.RefObject<HTMLDivElement>;
  useMapLibre?: boolean;
}

export const MapWrapper: React.FC<MapWrapperProps> = (props) => {
  const [useMapLibre, setUseMapLibre] = useState(() => {
    const storedPref = localStorage.getItem('use-maplibre');
    return props.useMapLibre ?? (storedPref === 'true' ? true : false);
  });
  
  useEffect(() => {
    localStorage.setItem('use-maplibre', useMapLibre.toString());
  }, [useMapLibre]);
  
  useEffect(() => {
    if (props.useMapLibre !== undefined && props.useMapLibre !== useMapLibre) {
      setUseMapLibre(props.useMapLibre);
    }
  }, [props.useMapLibre, useMapLibre]);

  return (
    <div className="h-full relative">
      {/* Map container - always below panels (z-index: 1000) */}
      <div className="absolute inset-0">
        {useMapLibre ? (
          <MapPanelMapLibre {...props} />
        ) : (
          <MapPanel {...props} />
        )}
      </div>
      
      {/* Toggle button for development - above map but below panels */}
      {/* {process.env.NODE_ENV === 'development' && (
        <div className="absolute top-2 left-2">
          <button 
            className="bg-white px-2 py-1 rounded shadow text-sm"
            onClick={() => setUseMapLibre(prev => !prev)}
          >
            Using: {useMapLibre ? 'MapLibre GL' : 'Leaflet'}
          </button>
        </div>
      )} */}
    </div>
  );
};